import React, { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { MailOutlined, UserOutlined, FileTextOutlined, CloseOutlined } from '@ant-design/icons';
const Support = ({ visible, handleCancel, handleSubmit, loading }) => {
  const [form] = Form.useForm();
  const [modalWidth, setModalWidth] = React.useState(getModalWidth());

function getModalWidth() {
  return window.innerWidth < 768 ? '90%' : '40%';
}
 useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Restore on unmount
    };
  }, [visible]);

React.useEffect(() => {
  const handleResize = () => setModalWidth(getModalWidth());
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  const onFinish = (values) => {
    handleSubmit(values);
  };

  return (
    <Modal
      title="Contact Support"
      open={visible}
      onCancel={handleCancel}
    //   width={'40%'}
//   className="support-modal"
        width={'450px'}


      destroyOnClose
      maskClosable={false}
      keyboard={false}
      closeIcon={<CloseOutlined />}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 20 }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter your name' }]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="Enter your name"
          />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Enter a valid email address' }
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="Enter your email"
          />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please describe your issue' }]}
        >
          <Input.TextArea
            rows={4}
            prefix={<FileTextOutlined />}
            placeholder="Describe your issue or inquiry"
          />
        </Form.Item>

        <Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <Button onClick={()=>console.log(form,"formmmmm")}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Support;
